// import React, { useState, useEffect, useContext, useRef } from "react";
// import "./personalDetails.css";
// import Backdrop from "@mui/material/Backdrop";
// import Box from "@mui/material/Box";
// import Modal from "@mui/material/Modal";
// import Fade from "@mui/material/Fade";
// import Button from "@mui/material/Button";
// import Typography from "@mui/material/Typography";
// import { colors } from "@mui/material";
// import successImg from "../../assets/images/successImg.png";
// import { useFormik } from "formik";
// import { axiosInstance } from "../../axiosInstance";
// import { ToastContainer, toast } from "react-toastify";
// import { object, string } from "yup";
// import translations from "./translation.json";
// import { LanguageContext } from "../../Components/LanguageContext";
// import { useDispatch } from "react-redux";
// import { setPersonalDetails } from "../../appRedux/store";
// import * as Yup from "yup";
// import axios from "axios";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 300,
//   bgcolor: "background.paper", //box color
//   border: "1px solid white", //box border
//   boxShadow: 24,
//   pt: 2,
//   px: 0,
//   pb: 3,
// };

// const SUPPORTED_FORMATS = [
//   "image/jpeg",
//   "image/png",
//   "image/jpg",
//   "image/webp",
// ];
// const PersonalSchema = Yup.object().shape({
//   name: Yup.string().required("Full Name is Required"),
//   gender: Yup.string().required("Gender is required"),
//   dob: Yup.string().required("Date of birth is required"),
//   tob: Yup.string().required("Time of birth is required"),
//   // height: Yup.string().required("Height is required"),
//   height: Yup.string()
//     .required("Height is required")
//     .matches(/^[4-7]\.\d$/, "Height is required"),

//   religion: Yup.string().required("Religion is required"),
//   mother_tongue: Yup.string().required("Mother tongue is required"),
//   caste: Yup.string().required("Caste is required"),
//   profile: Yup.mixed()
//     .test("fileCount", "You can only upload up to 5 images", (value) => {
//       return value && value.length <= 5;
//     })
//     // .test(
//     //   "fileFormat",
//     //   "Only PNG, JPG, JPEG, or WEBP images are allowed",
//     //   (value) => {
//     //     if (!value || value.length === 0) return false;
//     //     return value.every((file) => SUPPORTED_FORMATS.includes(file.type));
//     //   }
//     // )
//     .required("At least one image is required"),
// });

// export function PersonalDetails() {
//   // const dispatch = useDispatch();

//   const { language } = useContext(LanguageContext);
//   const [open, setOpen] = React.useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   // const [user, setUser] = useState();
//   const [religion, setReligion] = useState([]);
//   const [religionId, setReligionId] = useState();
//   const [casteId, setCasteId] = useState();
//   const [caste, setCaste] = useState([]);
//   const[subcaste,setSubCaste]=useState([]);

//   const nameRef = useRef(null);
//   const gender1Ref = useRef(null);
//   const dobRef = useRef(null);
//   const tob1Ref = useRef(null);
//   const height1Ref = useRef(null);
//   const religion1Ref = useRef(null);
//   const mother_tongue1Ref = useRef(null);
//   const caste1Ref = useRef(null);
//   const profileRef = useRef(null);

//   const [selectedProfileFile, setSelectedProfileFile] = useState(null);
//   const [profileImgPreview, setProfileImgPreview] = useState([]);

//   const formik = useFormik({
//     initialValues: {
//       profile: [],
//       name: "",
//       gender: "",
//       dob: "",
//       tob: "",
//       pob: "",
//       rashi: "",
//       nakshatra: "",
//       height: "",
//       marital_status: "",
//       religion: "",
//       mother_tongue: "",
//       caste: "",
//       sub_caste: "",
//       gotra: "",
//       manglik: "",
//       education: "",
//       college_name: "",
//       employed_in: "",
//       organization_name: "",
//       annual_income: "",
//     },
//     validationSchema: PersonalSchema,
//     onSubmit: async (values) => {
//       const fieldRefs = {
//         name: nameRef,
//         gender: gender1Ref,
//         dob: dobRef,
//         tob: tob1Ref,
//         height: height1Ref,
//         religion: religion1Ref,
//         mother_tongue: mother_tongue1Ref,
//         caste: caste1Ref,
//         profile: profileRef,
//       };

//       Object.keys(formik.errors).some((field) => {
//         const ref = fieldRefs[field];
//         if (ref?.current) {
//           ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
//           ref.current.focus();
//           return true; // stop after first error
//         }
//         return false;
//       });

//       try {
//         const dataToSave = {
//           ...values,
//           profile: values.profile,
//         };

//         // Save the form values and file names in localStorage
//         localStorage.setItem("personalDetails", JSON.stringify(dataToSave));

//         handleOpen(); // Show success modal
//       } catch (error) {
//         console.error("Error saving to localStorage:", error);
//       }
//     },
//   });

//   // get and set form data from localStorage to fields
//   useEffect(() => {
//     const personalDetails = localStorage.getItem("personalDetails");
//     if (personalDetails) {
//       try {
//         const parsedData = JSON.parse(personalDetails);
//         formik.setValues(parsedData);
//       } catch (err) {
//         console.error("Error parsing saved data:", err);
//       }
//     }
//   }, []);

//   // async function LoadReligion(){
//   //   const response=await get("http://devapi.naticharami.in/api/v1/dropdown/choices");
//   //   const data=response.data;
//   //   console.log("religion",data.religion);
//   //   setReligion(data.religion);
//   // }

//   async function LoadReligion() {
//     try {
//       const response = await axios.get(
//         "http://devapi.naticharami.in/api/v1/dropdown/choices"
//       );

//       if (response.status === 200 && response.data) {
//         console.log("religion", response.data.religion);
//         setReligion(response.data.religion);
//       } else {
//         console.error("Unexpected response format or status", response);
//       }
//     } catch (error) {
//       console.error("Failed to load religion data:", error.message);
//       // You can add more details for debugging
//       if (error.response) {
//         console.error("Server responded with:", error.response.data);
//       } else if (error.request) {
//         console.error("No response received. Request details:", error.request);
//       } else {
//         console.error("Error setting up request:", error.message);
//       }
//     }
//   }

//   async function LoadCaste(religionId) {
//     const response = await axios.get(
//       `https://devapi.naticharami.in/api/v1/dropdown/caste/${religionId}`
//     );
//     const data = response.data;
//     console.log("caste", data);
//     setCaste(data);
//   }
//   useEffect(() => {
//     LoadReligion();
//   }, []);

//   useEffect(() => {
//     if (religionId) {
//       LoadCaste(religionId);
//     }
//   }, [religionId]);

//    async function LoadSubCaste(casteId) {
//     const response = await axios.get(
//       `https://devapi.naticharami.in/api/v1/dropdown/sub-caste/${casteId}`
//     );
//     const data = response.data;
//     console.log("subcaste", data);
//     setSubCaste(data);
//   }
//   useEffect(() => {
//     if (casteId) {
//       LoadSubCaste(casteId);
//     }
//   }, [casteId]);

//   return (
//     <form onSubmit={formik.handleSubmit}>
//       <div className="basicMainContainer">
//         <div>
//           {/* row -1 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].upload_biodata}
//               </div>
//               <div className="basicTextbox">
//                 <input type="file" style={{ padding: "7px" }}></input>
//                 <div className="maxText">
//                   Please upload your bio-data file, and we’ll automatically fill
//                   out the form for you.
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row 0 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].upload_photo}
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="file"
//                   multiple
//                   accept="image/*"
//                   style={{ padding: "7px" }}
//                   id="profile"
//                   onBlur={formik.handleBlur}
//                   onChange={async (e) => {
//                     const files = Array.from(e.target.files);
//                     if (files.length > 0) {
//                       setProfileImgPreview(
//                         files.map((file) => URL.createObjectURL(file))
//                       );
//                       setSelectedProfileFile(files);

//                       const base64Promises = files.map(
//                         (file) =>
//                           new Promise((resolve, reject) => {
//                             const reader = new FileReader();
//                             reader.readAsDataURL(file);
//                             reader.onload = () =>
//                               resolve({
//                                 name: file.name,
//                                 type: file.type,
//                                 data: reader.result,
//                               });
//                             reader.onerror = (error) => reject(error);
//                           })
//                       );

//                       const base64Images = await Promise.all(base64Promises);
//                       console.log("base64Images:", base64Images); // Debug

//                       const base64Strings = base64Images.map((img) => img.data);
//                       console.log("base64Strings:", base64Strings); // Debug

//                       const existingValues = {
//                         ...formik.values,
//                         profile: base64Strings,
//                       };

//                       localStorage.setItem(
//                         "personalDetails",
//                         JSON.stringify(existingValues)
//                       );
//                       formik.setFieldValue("profile", base64Strings);
//                     }
//                   }}
//                   className={
//                     formik.touched.profile && formik.errors.profile
//                       ? "error"
//                       : ""
//                   }
//                 />
//                 <div>
//                   {formik.touched.profile && formik.errors.profile && (
//                     <div className="text-danger">{formik.errors.profile}</div>
//                   )}
//                 </div>
//               </div>
//               <div className="wallet-label">Can add upto 5 images</div>
//               <div className="image-preview-container">
//                 {profileImgPreview.map((src, index) => (
//                   <img
//                     key={index}
//                     src={src}
//                     alt={`Preview ${index}`}
//                     className="image-preview"
//                   />
//                 ))}
//               </div>
//             </div>
//             <div
//               className="form-check form-switch d-flex align-items-center"
//               style={{ marginLeft: "-35px" }}
//             >
//               <label
//                 className="form-check-label lableName"
//                 htmlFor="blurSwitch"
//               >
//                 {translations[language].blur_image}
//               </label>
//               <input
//                 className="form-check-input"
//                 type="checkbox"
//                 id="blurSwitch"
//                 style={{
//                   marginTop: "10px",
//                   fontSize: "25px",
//                   marginLeft: "20px",
//                 }}
//               />
//             </div>
//           </div>
//           {/* row1 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].full_name}{" "}
//                 <span className="text-danger">*</span>
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   onChange={formik.handleChange}
//                   value={formik.values.name}
//                   placeholder="Enter Full Name"
//                   onBlur={formik.handleBlur}
//                   className={
//                     formik.touched.name && formik.errors.name ? "error" : ""
//                   }
//                 />
//                 <div>
//                   {formik.touched.name && formik.errors.name && (
//                     <div className="text-danger">{formik.errors.name}</div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].gender}{" "}
//                 <span className="text-danger">*</span>
//               </div>
//               <div>
//                 <select
//                   // className="dropdown-btnBasic"
//                   name="gender"
//                   id="gender"
//                   value={formik.values.gender}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   className={`dropdown-btnBasic ${
//                     formik.touched.gender && formik.errors.gender ? "error" : ""
//                   }`}
//                 >
//                   <option>Select</option>
//                   <option>Male</option>
//                   <option>Female</option>
//                 </select>
//                 <div>
//                   {formik.touched.gender && formik.errors.gender && (
//                     <div className="text-danger">{formik.errors.gender}</div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row2 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].dob}{" "}
//                 <span className="text-danger">*</span>
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="date"
//                   id="dob"
//                   name="dob"
//                   onChange={formik.handleChange}
//                   value={formik.values.dob}
//                   onBlur={formik.handleBlur}
//                   max={new Date().toISOString().split("T")[0]}
//                   className={
//                     formik.touched.dob && formik.errors.dob ? "error" : ""
//                   }
//                 />
//                 <div>
//                   {formik.touched.dob && formik.errors.dob && (
//                     <div className="text-danger">{formik.errors.dob}</div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].tob}
//                 <span className="text-danger">*</span>
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="time"
//                   step="1" // enables seconds
//                   id="tob"
//                   onChange={formik.handleChange}
//                   value={formik.values.tob}
//                   onBlur={formik.handleBlur}
//                   placeholder="Enter Time Of Birth"
//                   className={
//                     formik.touched.tob && formik.errors.tob ? "error" : ""
//                   }
//                 />
//                 <div>
//                   {formik.touched.tob && formik.errors.tob && (
//                     <div className="text-danger">{formik.errors.tob}</div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row3 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].pob}{" "}
//                 <span className="text-danger">*</span>
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="text"
//                   id="pob"
//                   name="pob"
//                   onChange={formik.handleChange}
//                   value={formik.values.pob}
//                   onBlur={formik.handleBlur}
//                   placeholder="Enter Place Of Birth"
//                   className={
//                     formik.touched.pob && formik.errors.pob ? "error" : ""
//                   }
//                 />
//                 <div>
//                   {formik.touched.pob && formik.errors.pob && (
//                     <div className="text-danger">{formik.errors.pob}</div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">{translations[language].rashi}</div>
//               <div>
//                 <div className="basicTextbox">
//                   {/* <input
//                     type="text"
//                     id="rashi"
//                     onChange={formik.handleChange}
//                     value={formik.values.rashi}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Rashi"
//                   /> */}
//                   <select
//                     name="rashi"
//                     id="rashi"
//                     value={formik.values.rashi}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     className={`dropdown-btnBasic ${
//                       formik.touched.rashi && formik.errors.rashi ? "error" : ""
//                     }`}
//                   >
//                     <option value="" disabled>
//                       Select Rashi
//                     </option>
//                     <option>Mesham</option>
//                     <option>Vrushabham</option>
//                     <option>Midhunam</option>
//                     <option>Karkatakam</option>
//                     <option>Simham</option>
//                     <option>Kanya</option>
//                     <option>Tula</option>
//                     <option>Vruschikam</option>
//                     <option>Dhanussu</option>
//                     <option>Makaram</option>
//                     <option>Kumbham</option>
//                     <option>Meenam</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row4 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].nakshatra}
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   {/* <input
//                     type="text"
//                     id="nakshatra"
//                     onChange={formik.handleChange}
//                     value={formik.values.nakshatra}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Nakshatra"
//                   /> */}
//                   <select
//                     name="nakshatra"
//                     id="nakshatra"
//                     value={formik.values.nakshatra}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     className={`dropdown-btnBasic ${
//                       formik.touched.nakshatra && formik.errors.nakshatra
//                         ? "error"
//                         : ""
//                     }`}
//                   >
//                     <option value="" disabled>
//                       Select Nakshatra
//                     </option>
//                     <option>Anuraadha</option>
//                     <option>Arudra</option>
//                     <option>Ashlesha</option>
//                     <option>Ashwini</option>
//                     <option>Bharani</option>
//                     <option>Chittaa</option>
//                     <option>Dhanishta</option>
//                     <option>Asthami</option>
//                     <option>Jyesthaa</option>
//                     <option> Kritika</option>
//                     <option> Maghaa</option>
//                     <option>Mula</option>
//                     <option> Mrigasiraa</option>
//                     <option>Punarvasu</option>
//                     <option>Poorvashaadha</option>
//                     <option> Poorvabhadraa</option>
//                     <option>Pubba</option>
//                     <option>Pushya</option>
//                     <option> Revati</option>
//                     <option>Rohini</option>
//                     <option>Shatabhisha</option>
//                     <option>Shravana</option>
//                     <option>Swaati</option>
//                     <option>Uttarashaadha</option>
//                     <option> Uttaraa bhadra</option>
//                     <option>Uttara</option>
//                     <option>Vishaakha</option>
//                   </select>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].height}
//                 <span className="text-danger">*</span>
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   <select
//                     name="height"
//                     id="height"
//                     value={formik.values.height}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     className={`dropdown-btnBasic ${
//                       formik.touched.height && formik.errors.height
//                         ? "error"
//                         : ""
//                     }`}
//                   >
//                     <option value="" disabled>
//                       Select Height
//                     </option>
//                     <option value="4.0">4.0</option>
//                     <option value="4.1">4.1</option>
//                     <option value="4.2">4.2</option>
//                     <option value="4.3">4.3</option>
//                     <option value="4.4">4.4 </option>
//                     <option value="4.5">4.5 </option>
//                     <option value="4.6">4.6</option>
//                     <option value="4.7">4.7 </option>
//                     <option value="4.8">4.8 </option>
//                     <option value="4.9">4.9 </option>
//                     <option value="4.10">4.10</option>
//                     <option value="4.11">4.11</option>
//                     <option value="5.0">5.0 </option>
//                     <option value="5.1">5.1 </option>
//                     <option value="5.2">5.2 </option>
//                     <option value="5.3">5.3 </option>
//                     <option value="5.4">5.4 </option>
//                     <option value="5.5">5.5 </option>
//                     <option value="5.6">5.6 </option>
//                     <option value="5.7">5.7 </option>
//                     <option value="5.8">5.8 </option>
//                     <option value="5.9">5.9 </option>
//                     <option value="5.10">5.10 </option>
//                     <option value="5.11">5.11 </option>
//                     <option value="6.0">6.0 </option>
//                     <option value="6.1">6.1 </option>
//                     <option value="6.2">6.2 </option>
//                     <option value="6.3">6.3 </option>
//                     <option value="6.4">6.4 </option>
//                     <option value="6.5">6.5 </option>
//                     <option value="6.6">6.6 </option>
//                     <option value="6.7">6.7 </option>
//                     <option value="6.8">6.8 </option>
//                     <option value="6.9">6.9 </option>
//                     <option value="6.10">6.10</option>
//                     <option value="6.11">6.11</option>
//                     <option value="7.0">7.0 </option>
//                     <option value="7.1">7.1 </option>
//                     <option value="7.2">7.2 </option>
//                     <option value="7.3">7.3 </option>
//                     <option value="7.4">7.4 </option>
//                     <option value="7.5">7.5 </option>
//                     <option value="7.6">7.6 </option>
//                     <option value="7.7">7.7 </option>
//                     <option value="7.8">7.8 </option>
//                     <option value="7.9">7.9 </option>
//                     <option value="7.10">7.10 </option>
//                     <option value="7.11">7.11 </option>
//                   </select>
//                   <div>
//                     {formik.touched.height && formik.errors.height && (
//                       <div className="text-danger">{formik.errors.height}</div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row5 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].marital_status}
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   <input
//                     type="text"
//                     id="marital_status"
//                     onChange={formik.handleChange}
//                     value={formik.values.marital_status}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Marital Status"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].religion}
//                 <span className="text-danger">*</span>
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   {/* <input
//                     type="text"
//                     id="religion"
//                     name="religion"
//                     onChange={formik.handleChange}
//                     value={formik.values.religion}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Religion"
//                     className={
//                       formik.touched.religion && formik.errors.religion
//                         ? "error"
//                         : ""
//                     }
//                   /> */}
//                   <select
//                     name="religion"
//                     id="religion"
//                     value={formik.values.religion}
//                     onChange={(e) => {
//                       const selectedId = e.target.value;
//                       formik.setFieldValue("religion", selectedId);
//                       setReligionId(selectedId);
//                       console.log("Selected Religion ID:", selectedId);
//                     }}
//                     onBlur={formik.handleBlur}
//                     className={`dropdown-btnBasic ${
//                       formik.touched.religion && formik.errors.religion
//                         ? "error"
//                         : ""
//                     }`}
//                   >
//                     {religion.map((list) => (
//                       <option value={list.id} key={list.id}>
//                         {list.name}
//                       </option>
//                     ))}
//                   </select>

//                   <div>
//                     {formik.touched.religion && formik.errors.religion && (
//                       <div className="text-danger">
//                         {formik.errors.religion}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row6 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].mother_tougue}{" "}
//                 <span className="text-danger">*</span>
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   <input
//                     type="text"
//                     id="mother_tongue"
//                     name="mother_tongue"
//                     onChange={formik.handleChange}
//                     value={formik.values.mother_tongue}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Mother Tongue"
//                     className={
//                       formik.touched.mother_tongue &&
//                       formik.errors.mother_tongue
//                         ? "error"
//                         : ""
//                     }
//                   />
//                   <div>
//                     {formik.touched.mother_tongue &&
//                       formik.errors.mother_tongue && (
//                         <div className="text-danger">
//                           {formik.errors.mother_tongue}
//                         </div>
//                       )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].caste}{" "}
//                 <span className="text-danger">*</span>
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   {/* <input
//                     type="text"
//                     id="caste"
//                     name="caste"
//                     onChange={formik.handleChange}
//                     value={formik.values.caste}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Caste"
//                     className={
//                       formik.touched.caste && formik.errors.caste ? "error" : ""
//                     }
//                   /> */}
//                   <select
//                     name="caste"
//                     id="caste"
//                     value={formik.values.caste}
//                     onChange={(e) => {
//                       const selectedId = e.target.value;
//                       formik.setFieldValue("caste", selectedId);
//                       setCasteId(selectedId);
//                       console.log("Selected Caste ID:", selectedId);
//                     }}
//                     onBlur={formik.handleBlur}
//                     className={`dropdown-btnBasic ${
//                       formik.touched.caste && formik.errors.caste ? "error" : ""
//                     }`}
//                   >
//                     <option value="">Select Caste</option>
//                     {caste.map((list) => (
//                       <option value={list.id} key={list.id}>
//                         {list.name}
//                       </option>
//                     ))}
//                   </select>
//                   <div>First Select Religion</div>
//                   <div>
//                     {formik.touched.caste && formik.errors.caste && (
//                       <div className="text-danger">{formik.errors.caste}</div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row7 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">{translations[language].subcaste}</div>
//               <div className="basicTextbox">
//                 {/* <input
//                   type="text"
//                   placeholder="Enter sub caste"
//                   id="sub_caste"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.sub_caste}
//                 /> */}
//                    <select
//                     name="sub_caste"
//                     id="sub_caste"
//                     value={formik.values.sub_caste}
//                     // onChange={(e) => {
//                     //   const selectedId = e.target.value;
//                     //   formik.setFieldValue("caste", selectedId);
//                     //   setCasteId(selectedId);
//                     //   console.log("Selected SubCaste ID:", selectedId);
//                     // }}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     className={`dropdown-btnBasic ${
//                       formik.touched.caste && formik.errors.caste ? "error" : ""
//                     }`}
//                   >
//                     <option value="">Select Sub Caste</option>
//                     {subcaste.map((list) => (
//                       <option value={list.id} key={list.id}>
//                         {list.name}
//                       </option>
//                     ))}
//                   </select>
//                   <div>First Select Caste</div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">{translations[language].gothram}</div>
//               <div className="basicTextbox">
//                 <input
//                   type="text"
//                   placeholder="Enter Gothram"
//                   id="gotra"
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   value={formik.values.gotra}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* row8 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">{translations[language].manglik}</div>
//               <div>
//                 <div className="basicTextbox">
//                   <input
//                     type="text"
//                     id="manglik"
//                     onChange={formik.handleChange}
//                     value={formik.values.manglik}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Manglik"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].education}
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   <input
//                     type="text"
//                     id="education"
//                     onChange={formik.handleChange}
//                     value={formik.values.education}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Education"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row9 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].college_name}
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="text"
//                   placeholder="Enter College Name"
//                   id="college_name"
//                   value={formik.values.college_name}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                 />
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].employed_in}
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   <input
//                     type="text"
//                     id="employed_in"
//                     onChange={formik.handleChange}
//                     value={formik.values.employed_in}
//                     onBlur={formik.handleBlur}
//                     placeholder="Enter Employee Designation"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* row10 */}
//           <div className="basicSubcontainer">
//             <div>
//               <div className="lableName">
//                 {translations[language].organization_name}
//               </div>
//               <div className="basicTextbox">
//                 <input
//                   type="text"
//                   placeholder="Enter Organization name"
//                   value={formik.values.organization_name}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   id="organization_name"
//                 />
//               </div>
//             </div>
//             <div>
//               <div className="lableName">
//                 {translations[language].annual_income}
//               </div>
//               <div>
//                 <div className="basicTextbox">
//                   <input
//                     type="text"
//                     id="annual_income"
//                     onChange={formik.handleChange}
//                     value={formik.values.annual_income}
//                     placeholder="Enter Annual Income"
//                     onBlur={formik.handleBlur}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div>
//           <div className="btnBasicSave">
//             <Button type="submit">{translations[language].btnSave}</Button>
//           </div>

//           <Modal
//             aria-labelledby="transition-modal-title"
//             aria-describedby="transition-modal-description"
//             open={open}
//             onClose={handleClose}
//             closeAfterTransition
//           >
//             <Fade in={open}>
//               <Box sx={style} className="modal-box">
//                 <img srcSet={successImg} />
//                 <Typography
//                   id="transition-modal-title"
//                   variant="h6"
//                   component="h2"
//                 >
//                   Thank You
//                 </Typography>
//                 <Typography id="transition-modal-description" sx={{ mt: 2 }}>
//                   The profile has been successfully updated
//                 </Typography>
//               </Box>
//             </Fade>
//           </Modal>
//         </div>
//       </div>
//     </form>
//   );
// }

import React, { useState, useEffect, useContext, useRef } from "react";
import "./personalDetails.css";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/successImg.png";
import { useFormik } from "formik";
import { axiosInstance } from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import { object, string } from "yup";
import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import { useDispatch } from "react-redux";
import { setPersonalDetails } from "../../appRedux/store";
import * as Yup from "yup";
import axios from "axios";
import { axiosInstance_user } from "../../axiosInstance_user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const SUPPORTED_FORMATS = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/webp",
];
const PersonalSchema = Yup.object().shape({
  name: Yup.string().required("this feild is required"),
  gender: Yup.string().required("this feild is required"),
  dob: Yup.string().required("this feild is required"),
  pob: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
    .required("this feild is required"),
  tob: Yup.string().required("this feild is required"),
  // height: Yup.string().required("Height is required"),
  height: Yup.string()
    .required("this feild is required")
    .matches(/^[4-7]\.\d$/, "this feild is required"),

  religion: Yup.string().required("this feild is required"),
  mother_tongue: Yup.string().required("this feild is required"),
  caste: Yup.string().required("Caste is required"),
  // profile: Yup.mixed()
  //   .test("fileCount", "You can only upload up to 5 images", (value) => {
  //     return value && value.length <= 5;
  //   })
  //   // .test(
  //   //   "fileFormat",
  //   //   "Only PNG, JPG, JPEG, or WEBP images are allowed",
  //   //   (value) => {
  //   //     if (!value || value.length === 0) return false;
  //   //     return value.every((file) => SUPPORTED_FORMATS.includes(file.type));
  //   //   }
  //   // )
  //   .required("At least one image is required"),
  profile: Yup.array()
    .min(1, "At least one image is required")
    .max(3, "You can only upload up to 3 images"),
});

export function PersonalDetails() {
  // const dispatch = useDispatch();

  const { language } = useContext(LanguageContext);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  // const [user, setUser] = useState();
  const [religion, setReligion] = useState([]);
  const [religionId, setReligionId] = useState();
  const [casteId, setCasteId] = useState();
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubCaste] = useState([]);
  const [motherTongue, setMotherTongue] = useState([]);

  const nameRef = useRef(null);
  const gender1Ref = useRef(null);
  const dobRef = useRef(null);
  const tob1Ref = useRef(null);
  const height1Ref = useRef(null);
  const religion1Ref = useRef(null);
  const mother_tongue1Ref = useRef(null);
  const caste1Ref = useRef(null);
  const profileRef = useRef(null);

  const [selectedProfileFile, setSelectedProfileFile] = useState([]);
  const [profileImgPreview, setProfileImgPreview] = useState([]);

  const formik = useFormik({
    initialValues: {
      profile: [],
      name: "",
      gender: "",
      dob: "",
      tob: "",
      pob: "",
      rashi: "",
      nakshatra: "",
      height: "",
      marital_status: "",
      religion: "",
      mother_tongue: "",
      caste: "",
      sub_caste: "",
      gotra: "",
      manglik: "",
      education: "",
      college_name: "",
      employed_in: "",
      organization_name: "",
      annual_income: "",
    },
    validationSchema: PersonalSchema,
    onSubmit: async (values) => {
      const fieldRefs = {
        name: nameRef,
        gender: gender1Ref,
        dob: dobRef,
        tob: tob1Ref,
        height: height1Ref,
        religion: religion1Ref,
        mother_tongue: mother_tongue1Ref,
        caste: caste1Ref,
        profile: profileRef,
      };

      Object.keys(formik.errors).some((field) => {
        const ref = fieldRefs[field];
        if (ref?.current) {
          ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
          ref.current.focus();
          return true; // stop after first error
        }
        return false;
      });
      // getting id on user select so converting id into name
      const selectedReligion = religion.find(
        (r) => r.id === Number(values.religion),
      );
      const selectedCaste = caste.find((c) => c.id === Number(values.caste));
      const selectedSubCaste = subcaste.find(
        (s) => s.id === Number(values.sub_caste),
      );
      const selectedMotherTongue = motherTongue.find(
        (m) => m.id === Number(values.mother_tongue),
      );

      try {
        const dataToSave = {
          ...values,
          religion: selectedReligion?.name || "",
          caste: selectedCaste?.name || "",
          sub_caste: selectedSubCaste?.name || "",
          mother_tongue: selectedMotherTongue?.name || "",
          profile: values.profile,
        };

        // Save the form values and file names in localStorage
        localStorage.setItem("personalDetails", JSON.stringify(dataToSave));

        handleOpen(); // Show success modal
        setTimeout(() => {
          handleClose();
        }, 1000);
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }
    },
  });

  // get and set form data from localStorage to fields
  useEffect(() => {
    const personalDetails = localStorage.getItem("personalDetails");
    if (personalDetails) {
      try {
        const parsedData = JSON.parse(personalDetails);

        formik.setValues(parsedData);
        if (parsedData.profile && parsedData.profile.length > 0) {
          setProfileImgPreview(parsedData.profile); // base64 strings can be directly used as image src
        }
      } catch (err) {
        console.error("Error parsing saved data:", err);
      }
    }
  }, []);
  // Religion prefill
  useEffect(() => {
    if (religion.length > 0 && formik.values.religion) {
      const matchedReligion = religion.find(
        (r) =>
          r.id === formik.values.religion || r.name === formik.values.religion,
      );
      if (matchedReligion) {
        formik.setFieldValue("religion", matchedReligion.id); // ensure correct id is set
        LoadCaste(matchedReligion.id);
      }
    }
  }, [religion]);
  // After casteList updates, set caste prefill if saved in localStorage
  useEffect(() => {
    if (caste.length > 0 && formik.values.caste) {
      const matchedCaste = caste.find(
        (c) => c.id === formik.values.caste || c.name === formik.values.caste,
      );
      if (matchedCaste) {
        formik.setFieldValue("caste", matchedCaste.id); // ensure correct id is set
        LoadSubCaste(matchedCaste.id);
      }
    }
  }, [caste]);

  // After subCasteList updates, set subCaste prefill
  useEffect(() => {
    if (subcaste.length > 0 && formik.values.sub_caste) {
      const matchedSubCaste = subcaste.find(
        (s) =>
          s.id === formik.values.sub_caste ||
          s.name === formik.values.sub_caste,
      );
      if (matchedSubCaste) {
        formik.setFieldValue("sub_caste", matchedSubCaste.id);
      }
    }
  }, [subcaste]);

  // For mother tongue prefill
  useEffect(() => {
    if (motherTongue.length > 0 && formik.values.mother_tongue) {
      const matched = motherTongue.find(
        (m) => m.name === formik.values.mother_tongue,
      );
      if (matched) {
        formik.setFieldValue("mother_tongue", matched.id);
      }
    }
  }, [motherTongue]);

  // async function LoadReligion(){
  //   const response=await axios.get("http://devapi.naticharami.in/api/v1/dropdown/choices");
  //   const data=response.data;
  //   console.log("religion",data.religion);
  //   setReligion(data.religion);
  // }

  async function LoadReligion() {
    try {
      const response = await axiosInstance_user.get("/dropdown/choices");

      if (response.status === 200 && response.data) {
        console.log("religion", response.data.religion);
        setReligion(response.data.religion);
        setMotherTongue(response.data.mother_tongue);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }

  async function LoadCaste(religionId) {
    const response = await axiosInstance_user.get(
      `/dropdown/caste/${religionId}`,
    );
    const data = response.data;
    console.log("caste", data);
    setCaste(data);
  }
  useEffect(() => {
    LoadReligion();
  }, []);

  useEffect(() => {
    if (religionId) {
      LoadCaste(religionId);
    }
  }, [religionId]);

  async function LoadSubCaste(casteId) {
    const response = await axiosInstance_user.get(
      `/dropdown/sub-caste/${casteId}`,
    );
    const data = response.data;
    console.log("subcaste", data);
    setSubCaste(data);
  }
  useEffect(() => {
    if (casteId) {
      LoadSubCaste(casteId);
    }
  }, [casteId]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="basicMainContainer">
        <div>
          {/* row -1 */}
          <div className="basicSubcontainer">
            {/* <div>
              <div className="lableName">
                {translations[language].upload_biodata}
              </div>
              <div className="basicTextbox">
                <input type="file" style={{ padding: "7px" }}></input>
                <div className="maxText">
                  Please upload your bio-data file, and we’ll automatically fill
                  out the form for you.
                </div>
              </div>
            </div> */}
          </div>
          {/* row 0 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].upload_photo}
              </div>
              <div className="basicTextbox">
                <input
                  type="file"
                  multiple
                  ref={profileRef}
                  accept="image/*"
                  style={{ padding: "7px" }}
                  id="profile"
                  onBlur={formik.handleBlur}
                  onChange={async (e) => {
                    const files = Array.from(e.target.files);
                    if (files.length > 0) {
                      setProfileImgPreview(
                        files.map((file) => URL.createObjectURL(file)),
                      );
                      setSelectedProfileFile(files);

                      const base64Promises = files.map(
                        (file) =>
                          new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () =>
                              resolve({
                                name: file.name,
                                type: file.type,
                                data: reader.result,
                              });
                            reader.onerror = (error) => reject(error);
                          }),
                      );

                      const base64Images = await Promise.all(base64Promises);
                      console.log("base64Images:", base64Images); // Debug

                      const base64Strings = base64Images.map((img) => img.data);
                      console.log("base64Strings:", base64Strings); // Debug

                      const existingValues = {
                        ...formik.values,
                        profile: base64Strings,
                      };

                      localStorage.setItem(
                        "personalDetails",
                        JSON.stringify(existingValues),
                      );
                      formik.setFieldValue("profile", base64Strings);
                    }
                  }}
                  className={
                    formik.touched.profile && formik.errors.profile
                      ? "error"
                      : ""
                  }
                />
                <div>
                  {formik.touched.profile && formik.errors.profile && (
                    <div className="text-danger">{formik.errors.profile}</div>
                  )}
                </div>
              </div>
              <div className="wallet-label">Can add upto 3 images</div>
              <div className="image-preview-container">
                {profileImgPreview.map((src, index) => (
                  <div className="image-preview-wrapper" key={index}>
                    <img
                      key={index}
                      src={src}
                      alt={`Preview ${index}`}
                      className="image-preview"
                    />
                    {/* Close button on image*/}
                    <button
                      type="button"
                      className="image-remove-btn"
                      onClick={() => {
                        // Remove preview
                        const updatedPreviews = profileImgPreview.filter(
                          (_, i) => i !== index,
                        );

                        // Remove selected file
                        const updatedFiles = Array.isArray(selectedProfileFile)
                          ? selectedProfileFile.filter((_, i) => i !== index)
                          : [];

                        // Remove base64 image from Formik
                        const currentProfile = Array.isArray(
                          formik.values.profile,
                        )
                          ? formik.values.profile
                          : [];

                        const updatedBase64 = currentProfile.filter(
                          (_, i) => i !== index,
                        );

                        // Update states
                        setProfileImgPreview(updatedPreviews);
                        setSelectedProfileFile(updatedFiles);

                        // Update Formik
                        formik.setFieldValue("profile", updatedBase64);

                        // Update localStorage
                        const updatedValues = {
                          ...formik.values,
                          profile: updatedBase64,
                        };

                        localStorage.setItem(
                          "personalDetails",
                          JSON.stringify(updatedValues),
                        );

                        // Reset input so same file can be selected again
                        if (profileRef.current) {
                          profileRef.current.value = "";
                        }
                      }}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* blur image  */}
            {/* <div
              className="form-check form-switch d-flex align-items-center"
              style={{ marginLeft: "-35px" }}
            >
              <label
                className="form-check-label lableName"
                htmlFor="blurSwitch"
              >
                {translations[language].blur_image}
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                id="blurSwitch"
                style={{
                  marginTop: "10px",
                  fontSize: "25px",
                  marginLeft: "20px",
                }}
              />
            </div> */}
          </div>
          {/* row1 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].full_name}{" "}
                <span className="text-danger">*</span>
              </div>
              <div className="basicTextbox">
                <input
                  type="text"
                  id="name"
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  placeholder="Enter Full Name"
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.name && formik.errors.name ? "error" : ""
                  }
                />
                <div>
                  {formik.touched.name && formik.errors.name && (
                    <div className="text-danger">{formik.errors.name}</div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].gender}{" "}
                <span className="text-danger">*</span>
              </div>
              <div>
                <select
                  // className="dropdown-btnBasic"
                  name="gender"
                  id="gender"
                  value={formik.values.gender}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.gender && formik.errors.gender ? "error" : ""
                  }`}
                >
                  <option>Select</option>
                  <option>Male</option>
                  <option>Female</option>
                </select>
                <div>
                  {formik.touched.gender && formik.errors.gender && (
                    <div className="text-danger">{formik.errors.gender}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* row2 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].dob}{" "}
                <span className="text-danger">*</span>
              </div>
              <div className="basicTextbox">
                <input
                  type="date"
                  id="dob"
                  name="dob"
                  onChange={formik.handleChange}
                  value={formik.values.dob}
                  onBlur={formik.handleBlur}
                  max={new Date().toISOString().split("T")[0]}
                  className={
                    formik.touched.dob && formik.errors.dob ? "error" : ""
                  }
                />
                <div>
                  {formik.touched.dob && formik.errors.dob && (
                    <div className="text-danger">{formik.errors.dob}</div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].tob}
                <span className="text-danger">*</span>
              </div>
              <div className="basicTextbox">
                <input
                  type="time"
                  step="1" // enables seconds
                  id="tob"
                  onChange={formik.handleChange}
                  value={formik.values.tob}
                  onBlur={formik.handleBlur}
                  placeholder="Enter Time Of Birth"
                  className={
                    formik.touched.tob && formik.errors.tob ? "error" : ""
                  }
                />
                <div>
                  {formik.touched.tob && formik.errors.tob && (
                    <div className="text-danger">{formik.errors.tob}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* row3 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].pob}{" "}
                <span className="text-danger">*</span>
              </div>
              <div className="basicTextbox">
                <input
                  type="text"
                  id="pob"
                  name="pob"
                  onChange={formik.handleChange}
                  value={formik.values.pob}
                  onBlur={formik.handleBlur}
                  placeholder="Enter Place Of Birth"
                  className={
                    formik.touched.pob && formik.errors.pob ? "error" : ""
                  }
                />
                <div>
                  {formik.touched.pob && formik.errors.pob && (
                    <div className="text-danger">{formik.errors.pob}</div>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">{translations[language].rashi}</div>
              <div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    id="rashi"
                    onChange={formik.handleChange}
                    value={formik.values.rashi}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Rashi"
                  /> */}
                  <select
                    name="rashi"
                    id="rashi"
                    value={formik.values.rashi}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.rashi && formik.errors.rashi ? "error" : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select Rashi
                    </option>
                    <option>Mesham</option>
                    <option>Vrushabham</option>
                    <option>Midhunam</option>
                    <option>Karkatakam</option>
                    <option>Simham</option>
                    <option>Kanya</option>
                    <option>Tula</option>
                    <option>Vruschikam</option>
                    <option>Dhanussu</option>
                    <option>Makaram</option>
                    <option>Kumbham</option>
                    <option>Meenam</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          {/* row4 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].nakshatra}
              </div>
              <div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    id="nakshatra"
                    onChange={formik.handleChange}
                    value={formik.values.nakshatra}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Nakshatra"
                  /> */}
                  <select
                    name="nakshatra"
                    id="nakshatra"
                    value={formik.values.nakshatra}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.nakshatra && formik.errors.nakshatra
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select Nakshatra
                    </option>
                    <option>Anuraadha</option>
                    <option>Arudra</option>
                    <option>Ashlesha</option>
                    <option>Ashwini</option>
                    <option>Bharani</option>
                    <option>Chittaa</option>
                    <option>Dhanishta</option>
                    <option>Asthami</option>
                    <option>Jyesthaa</option>
                    <option> Kritika</option>
                    <option> Maghaa</option>
                    <option>Mula</option>
                    <option> Mrigasiraa</option>
                    <option>Punarvasu</option>
                    <option>Poorvashaadha</option>
                    <option> Poorvabhadraa</option>
                    <option>Pubba</option>
                    <option>Pushya</option>
                    <option> Revati</option>
                    <option>Rohini</option>
                    <option>Shatabhisha</option>
                    <option>Shravana</option>
                    <option>Swaati</option>
                    <option>Uttarashaadha</option>
                    <option> Uttaraa bhadra</option>
                    <option>Uttara</option>
                    <option>Vishaakha</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].height}
                <span className="text-danger">*</span>
              </div>
              <div>
                <div className="basicTextbox">
                  <select
                    name="height"
                    id="height"
                    value={formik.values.height}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.height && formik.errors.height
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select Height
                    </option>
                    <option value="4.0">4.0</option>
                    <option value="4.1">4.1</option>
                    <option value="4.2">4.2</option>
                    <option value="4.3">4.3</option>
                    <option value="4.4">4.4 </option>
                    <option value="4.5">4.5 </option>
                    <option value="4.6">4.6</option>
                    <option value="4.7">4.7 </option>
                    <option value="4.8">4.8 </option>
                    <option value="4.9">4.9 </option>
                    <option value="4.10">4.10</option>
                    <option value="4.11">4.11</option>
                    <option value="5.0">5.0 </option>
                    <option value="5.1">5.1 </option>
                    <option value="5.2">5.2 </option>
                    <option value="5.3">5.3 </option>
                    <option value="5.4">5.4 </option>
                    <option value="5.5">5.5 </option>
                    <option value="5.6">5.6 </option>
                    <option value="5.7">5.7 </option>
                    <option value="5.8">5.8 </option>
                    <option value="5.9">5.9 </option>
                    <option value="5.10">5.10 </option>
                    <option value="5.11">5.11 </option>
                    <option value="6.0">6.0 </option>
                    <option value="6.1">6.1 </option>
                    <option value="6.2">6.2 </option>
                    <option value="6.3">6.3 </option>
                    <option value="6.4">6.4 </option>
                    <option value="6.5">6.5 </option>
                    <option value="6.6">6.6 </option>
                    <option value="6.7">6.7 </option>
                    <option value="6.8">6.8 </option>
                    <option value="6.9">6.9 </option>
                    <option value="6.10">6.10</option>
                    <option value="6.11">6.11</option>
                    <option value="7.0">7.0 </option>
                    <option value="7.1">7.1 </option>
                    <option value="7.2">7.2 </option>
                    <option value="7.3">7.3 </option>
                    <option value="7.4">7.4 </option>
                    <option value="7.5">7.5 </option>
                    <option value="7.6">7.6 </option>
                    <option value="7.7">7.7 </option>
                    <option value="7.8">7.8 </option>
                    <option value="7.9">7.9 </option>
                    <option value="7.10">7.10 </option>
                    <option value="7.11">7.11 </option>
                  </select>
                  <div>
                    {formik.touched.height && formik.errors.height && (
                      <div className="text-danger">{formik.errors.height}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row5 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].marital_status}
              </div>
              <div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="marital_status"
                    onChange={formik.handleChange}
                    value={formik.values.marital_status}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Marital Status"
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].religion}
                <span className="text-danger">*</span>
              </div>
              <div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    id="religion"
                    name="religion"
                    onChange={formik.handleChange}
                    value={formik.values.religion}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Religion"
                    className={
                      formik.touched.religion && formik.errors.religion
                        ? "error"
                        : ""
                    }
                  /> */}
                  <select
                    name="religion"
                    id="religion"
                    value={formik.values.religion}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      formik.setFieldValue("religion", selectedId);
                      setReligionId(selectedId);
                      console.log("Selected Religion ID:", selectedId);
                      // reset caste & sub caste whenever religion changes
                      formik.setFieldValue("caste", "");
                      formik.setFieldValue("sub_caste", "");
                      setCaste([]);
                      setSubCaste([]);
                    }}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.religion && formik.errors.religion
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="" disabled>
                      Select Religion
                    </option>
                    {religion.map((list) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>

                  <div>
                    {formik.touched.religion && formik.errors.religion && (
                      <div className="text-danger">
                        {formik.errors.religion}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row6 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].mother_tougue}{" "}
                <span className="text-danger">*</span>
              </div>
              <div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    id="mother_tongue"
                    name="mother_tongue"
                    onChange={formik.handleChange}
                    value={formik.values.mother_tongue}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Mother Tongue"
                    className={
                      formik.touched.mother_tongue &&
                      formik.errors.mother_tongue
                        ? "error"
                        : ""
                    }
                  /> */}
                  <select
                    name="mother_tongue"
                    id="mother_tongue"
                    value={formik.values.mother_tongue}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.mother_tongue &&
                      formik.errors.mother_tongue
                        ? "error"
                        : ""
                    }`}
                  >
                    <option value="">Select Mother Tongue</option>
                    {motherTongue.map((list) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>
                  <div>
                    {formik.touched.mother_tongue &&
                      formik.errors.mother_tongue && (
                        <div className="text-danger">
                          {formik.errors.mother_tongue}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].caste}{" "}
                <span className="text-danger">*</span>
              </div>
              <div>
                <div className="basicTextbox">
                  {/* <input
                    type="text"
                    id="caste"
                    name="caste"
                    onChange={formik.handleChange}
                    value={formik.values.caste}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Caste"
                    className={
                      formik.touched.caste && formik.errors.caste ? "error" : ""
                    }
                  /> */}
                  <select
                    name="caste"
                    id="caste"
                    value={formik.values.caste}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      formik.setFieldValue("caste", selectedId);
                      setCasteId(selectedId);
                      console.log("Selected Caste ID:", selectedId);
                      // reset sub caste whenever caste changes
                      formik.setFieldValue("sub_caste", "");
                      setSubCaste([]);
                    }}
                    onBlur={formik.handleBlur}
                    className={`dropdown-btnBasic ${
                      formik.touched.caste && formik.errors.caste ? "error" : ""
                    }`}
                  >
                    <option value="">Select Caste</option>
                    {caste.map((list) => (
                      <option value={list.id} key={list.id}>
                        {list.name}
                      </option>
                    ))}
                  </select>
                  <div>First Select Religion</div>
                  <div>
                    {formik.touched.caste && formik.errors.caste && (
                      <div className="text-danger">{formik.errors.caste}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* row7 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">{translations[language].subcaste}</div>
              <div className="basicTextbox">
                {/* <input
                  type="text"
                  placeholder="Enter sub caste"
                  id="sub_caste"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.sub_caste}
                /> */}
                <select
                  name="sub_caste"
                  id="sub_caste"
                  value={formik.values.sub_caste}
                  // onChange={(e) => {
                  //   const selectedId = e.target.value;
                  //   formik.setFieldValue("caste", selectedId);
                  //   setCasteId(selectedId);
                  //   console.log("Selected SubCaste ID:", selectedId);
                  // }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`dropdown-btnBasic ${
                    formik.touched.caste && formik.errors.caste ? "error" : ""
                  }`}
                >
                  <option value="">Select Sub Caste</option>
                  {subcaste.map((list) => (
                    <option value={list.id} key={list.id}>
                      {list.name}
                    </option>
                  ))}
                </select>
                <div>First Select Caste</div>
              </div>
            </div>
            <div>
              <div className="lableName">{translations[language].gothram}</div>
              <div className="basicTextbox">
                <input
                  type="text"
                  placeholder="Enter Gothram"
                  id="gotra"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.gotra}
                />
              </div>
            </div>
          </div>

          {/* row8 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">{translations[language].manglik}</div>
              <div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="manglik"
                    onChange={formik.handleChange}
                    value={formik.values.manglik}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Manglik"
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].education}
              </div>
              <div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="education"
                    onChange={formik.handleChange}
                    value={formik.values.education}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Education"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* row9 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].college_name}
              </div>
              <div className="basicTextbox">
                <input
                  type="text"
                  placeholder="Enter College Name"
                  id="college_name"
                  value={formik.values.college_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].employed_in}
              </div>
              <div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="employed_in"
                    onChange={formik.handleChange}
                    value={formik.values.employed_in}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Employee Designation"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* row10 */}
          <div className="basicSubcontainer">
            <div>
              <div className="lableName">
                {translations[language].organization_name}
              </div>
              <div className="basicTextbox">
                <input
                  type="text"
                  placeholder="Enter Organization name"
                  value={formik.values.organization_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  id="organization_name"
                />
              </div>
            </div>
            <div>
              <div className="lableName">
                {translations[language].annual_income}
              </div>
              <div>
                <div className="basicTextbox">
                  <input
                    type="text"
                    id="annual_income"
                    onChange={formik.handleChange}
                    value={formik.values.annual_income}
                    placeholder="Enter Annual Income"
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="btnBasicSave">
            <Button type="submit">{translations[language].btnSave}</Button>
          </div>

          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
          >
            <Fade in={open}>
              <Box sx={style} className="modal-box">
                <img srcSet={successImg} />
                <Typography
                  id="transition-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Thank You
                </Typography>
                <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                  The profile has been successfully updated
                </Typography>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </form>
  );
}
